import { translateEnum } from "../../providers";
import { dangerousSetInnerHTML } from "../../utils";

export default function I18nTranslateEnumCheckEmailError({ autoTranslate = "yes", value, param = {} }) {
	return dangerousSetInnerHTML({
		autoTranslate,
		text: translateEnum("check-email-error", value?.toLowerCase(), param),
	});
}
